import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadEffect } from "../../effect";
import { fitImageToContainer } from "../../helpers/elements";

var Preview = /*#__PURE__*/function (_UpploadEffect) {
  _inherits(Preview, _UpploadEffect);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    _this = _super.apply(this, arguments);
    _this.name = "preview";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1 18)\" fill=\"#000\" fill-rule=\"nonzero\"><path d=\"M244 40h-29V10c0-6-5-10-10-10H10C4 0 0 4 0 10v160c0 5 4 10 10 10h29v30c0 6 4 10 9 10h195c6 0 10-4 10-10V50c0-5-4-10-9-10zm-10 136l-40-45c-4-5-11-5-15 0l-17 19-38-45c-4-5-13-5-17 0l-49 58V60h176v116zM19 160V20h176v20H49c-6 0-10 5-10 10v110H19z\"/><ellipse cx=\"202.5\" cy=\"94\" rx=\"15.5\" ry=\"16\"/></g></svg>";

    _this.template = function (_ref) {
      var file = _ref.file;
      var image = URL.createObjectURL(file.blob);
      return "\n      <div class=\"uppload-preview-element\">\n        <img style=\"width: 20px\" alt=\"\" src=\"".concat(image, "\">\n      </div>\n    ");
    };

    _this.handlers = function (params) {
      var image = params.uppload.container.querySelector(".uppload-preview-element img");
      if (image) fitImageToContainer(params, image);
    };

    return _this;
  }

  return Preview;
}(UpploadEffect);

export { Preview as default };